import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const links = [
    { to: "/", label: "Início" },
    { to: "/sobre", label: "Como Funciona" },
    { to: "/planos", label: "Planos & Pacotes" },
    { to: "/espacos", label: "Nossos Preços" },
    { to: "/contato", label: "Localização" },
    { to: "/faq", label: "FAQ" },
  ];
  const WA_HREF = "https://wa.me/5521975968405?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20o%20VM%20Corporate";

  return (
    <header className="glass-nav fixed top-0 left-0 right-0 z-50" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <div className="w-10 h-10 rounded-md border border-[#D4AF37]/40 flex items-center justify-center group-hover:border-[#D4AF37] transition">
            <span className="font-display font-bold text-[#D4AF37] text-lg">VM</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-semibold text-white text-base tracking-tight">VM Corporate</div>
            <div className="text-[10px] text-white/50 uppercase tracking-[0.2em]">Coworking Premium</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={`text-sm font-medium transition ${
                location.pathname === l.to ? "text-[#D4AF37]" : "text-white/70 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={WA_HREF}
            target="_blank"
            rel="noreferrer"
            className="text-sm font-semibold text-emerald-400 hover:text-emerald-300 transition px-2"
            data-testid="nav-whatsapp-btn"
          >
            WhatsApp
          </a>
          {user && user !== false ? (
            <Link
              to={user.role === "client" ? "/portal" : "/admin"}
              className="btn-gold px-5 py-2.5 rounded-md text-sm"
              data-testid="nav-dashboard-btn"
            >
              Acessar Painel
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn-ghost-gold px-5 py-2.5 rounded-md text-sm" data-testid="nav-login-btn">
                Entrar
              </Link>
              <Link to="/planos" className="btn-gold px-5 py-2.5 rounded-md text-sm" data-testid="nav-cta-btn">
                Reservar Tour
              </Link>
            </>
          )}
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0A1128]/95 backdrop-blur-xl">
          <div className="px-6 py-6 space-y-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="block text-white/80 hover:text-[#D4AF37] text-base"
                data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
              >
                {l.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-white/10 flex gap-3">
              <a href={WA_HREF} target="_blank" rel="noreferrer" className="block text-emerald-400 font-semibold text-base flex-1 text-center py-2" data-testid="mobile-nav-whatsapp">WhatsApp</a>
              {user && user !== false ? (
                <Link to={user.role === "client" ? "/portal" : "/admin"} className="btn-gold px-4 py-2 rounded-md text-sm flex-1 text-center">
                  Painel
                </Link>
              ) : (
                <>
                  <Link to="/login" className="btn-ghost-gold px-4 py-2 rounded-md text-sm flex-1 text-center">Entrar</Link>
                  <Link to="/planos" className="btn-gold px-4 py-2 rounded-md text-sm flex-1 text-center">Planos</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
